"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedSignalsDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.NamedSignalsDefinition = (0, services_definitions_1.defineService)('viewer-core/named-signals');
//# sourceMappingURL=index.js.map